import { Grid, Paper, Typography } from "@material-ui/core";
import React, { useMemo } from "react";

import { Box, BoxOwner } from "../../../../dtos/box";

interface Props {
    box: Box;
    owners: BoxOwner[];
}

export function BoxInfoCard({ box, owners }: Props) {
    const leaseStart = useMemo(() => {
        return box.leaseStartDate ? new Date(box.leaseStartDate).toLocaleDateString() : "";
    }, [box]);

    const leaseExpiration = useMemo(() => {
        if (box.leaseEndDate) {
            return new Date(box.leaseEndDate).toLocaleDateString();
        }
        if (owners.length > 0) {
            return "No expiration";
        }
        return "";
    }, [box, owners]);

    return (
        <Paper style={{ padding: "20px" }}>
            <Grid container={true} spacing={3} style={{ maxWidth: "1000px" }}>
                <CardItem label="Box Number" value={`${box.number}`} testId="box-number" />
                <CardItem label="Size" value={box.size} testId="box-size" />
                <CardItem label="Multiple Owners" value={owners.length > 1 ? "Yes" : "No"} testId="multiple-owners" />
                <CardItem label="Lease Start Date" value={leaseStart} testId="lease-start-date" />
                <CardItem label="Lease End Date" value={leaseExpiration} danger={box.isExpired} testId="lease-end-date" />
                <CardItem label="Location" value={box.location} testId="location" />
            </Grid>
        </Paper>
    );
}

function CardItem({
    label,
    value,
    danger = false,
    testId,
}: {
    label: string;
    value: string;
    danger?: boolean;
    testId: string;
}) {
    const constTestId = `box-info-card-${testId}`;
    return (
        <Grid item={true} sm={4} xs={6}>
            <Grid container={true}>
                <Grid item={true} xs={6}>
                    <Typography data-testid={`${constTestId}-label`}>
                        <b>{label}:</b>
                    </Typography>
                </Grid>
                <Grid item={true} xs={6}>
                    <Typography data-testid={`${constTestId}-value`} color={danger ? "error" : "textPrimary"}>
                        {value}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}
